import './App.css';
import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home.jsx';
import SignupSignIn from './pages/SignupSignIn.jsx';
import Admin from './pages/Admin.jsx';
import Account from './pages/Account.jsx';

const App = () => {
  return (
    <Router className='App'>
      <div>
        <Switch>
          <Route path='/admin'>
            <Admin />
          </Route>
          <Route path='/account'>
            <Account />
          </Route>
          <Route path='/sign'>
            <SignupSignIn />
          </Route>
          <Route exact path='/'>
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
};

export default App;
